import sc from 'styled-components';

import React from 'react';
import { DRAWER_MARGIN_HEIGHT, DRAWER_MARGIN_WIDTH } from './styleConstants';

export default sc.section`
    margin: ${DRAWER_MARGIN_HEIGHT}, ${DRAWER_MARGIN_WIDTH};
    height: 100%;
    width: 100%;
`;
